<template>
  <select
    v-model="fieldValue"
    class="form-control flex-fill mb-1 mb-md-0"
    :class="className"
    :required="required"
    @change="onChangeCallback"
  >
    <option
      v-for="item in items"
      :key="item.value"
      :value="item.value"
    >
      {{ item.text }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    name: {type: String, default: ''},
    idName: {type: String, default: ''},
    className: {type: String, default: ''},
    value: {type: Number, default: null},
    values: {type: Array, default: null},
    options: {type: Array, default: null},
    onChange: { type: Function, default: null },
    required: { type: Boolean, default: false },
  },
  data() {
    return {
      items: [],
      fieldValue: this.value,
    }
  },
  watch: {
    values: function (newVal, oldVal) {
      this.processItems()
    },
    value: function (newVal, oldVal) {
      this.fieldValue = this.value
    },
  },
  created() {
    this.processItems()
  },
  methods: {
    processItems() {
      this.items = []
      for (let index = 0; index < this.values.length; index++) {
        this.items.push({ value: this.values[index], text: this.options[index] })
      }
    },
    onChangeCallback() {
      if (this.onChange != null) {
        this.onChange(this.fieldValue)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  select {
    width: auto;
    display: inline-block;
    margin-right: 10px;
  }
</style>
